<template>
  <div>
    <StatusBanner>
      <template slot="header">
        {{headerText}}.
      </template>
      <template slot="actions">
        No one will receive calls or see texts from this number. Everything new gets thrown out. You can <button @click="cleanse" class="text-blue-400 underline">un-block it</button>.
      </template>
    </StatusBanner>
  </div>
</template>

<script>
import _get         from 'lodash-es/get'
import parse        from 'date-fns/parse'
import isToday      from 'date-fns/is_today'
import isYesterday  from 'date-fns/is_yesterday'

import StatusBanner from '@/components/StatusBanner.vue'

export default {
  components: {
    StatusBanner
  },

  props: {
    cleanse: {
      type: Function,
      default: () => { console.warn('Cardstock - HomeNumberBlockedBanner: unhandled cleanse function')}
    },
    blockedAt: {type: String, default: null},
    blockingTeacher: {type: Object, default: () => { return {} }},
    trashLink: {type: Object}
  },

  computed: {
    headerText() {
      if (_get(this.blockingTeacher, 'isCurrent') == true) {
        return 'You blocked this number ' + this.formattedBlockedAt
      } else if (_get(this.blockingTeacher, 'last', null) != null ) {
        return _get(this.blockingTeacher, 'last') + ' blocked this number ' + this.formattedBlockedAt
      } else {
        return 'This number was blocked ' + this.formattedBlockedAt
      }
    },

    formattedBlockedAt() {
      if (isToday(this.blockedAt)) {
        return "today"
      } else if (isYesterday(this.blockedAt)) {
        return "yesterday"
      } else {
        return 'on ' + parse(this.blockedAt).toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
      }
    },
  }
}
</script>
